export default "__VITE_ASSET__BFVwBpL___"